import { Navigate } from 'react-router';
import { ReactElement } from 'react';

import { ROUTES } from '../../utils/routes';
import { useAppSelector } from '../../../store/store';
import { wishListsSelector } from '../../store/whish-list-selectors';

export const WishListRedirect = (): ReactElement => {
    const wishLists = useAppSelector(wishListsSelector);

    const id = wishLists.find(list => list.isDefault)?.id.toString() ?? 'default';
    const url = ROUTES.wishList.detail.replace(':id', id);

    return <Navigate to={url} replace={true} />;
};
